export default __webpack_public_path__ + "i18n/translation-ja.d87d06e2.json";